/*
 * variant-gallery.js
 * ------------------
 * Per-variant product galleries.
 *
 * Liquid renders every non-orphan media item into the DOM and stamps each one
 * with data-vg-variants=" 123 456 " (the variant IDs that media belongs to).
 * Items not belonging to the variant selected on page load are rendered with
 * data-vg-hidden="true" already set, so first paint is correct with no flash
 * and no JS required.
 *
 * This file handles what happens AFTER the shopper switches variant: retag
 * which items are visible, then rebuild the Swiper instances so slide counts,
 * pagination and thumbs all match the new set.
 *
 * Depends on sliderInit / subSliderInit / popupSliderInit from global.js.
 */
(function () {
  'use strict';

  var HIDDEN = 'data-vg-hidden';
  var SELECTOR = '[data-vg-variants]';

  function hide(el) { el.setAttribute(HIDDEN, 'true'); }
  function show(el) { el.removeAttribute(HIDDEN); }

  function belongsTo(el, variantId) {
    var tags = el.getAttribute('data-vg-variants') || '';
    return tags.indexOf(' ' + variantId + ' ') !== -1;
  }

  function filterTo(variantId) {
    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return false;

    var shown = 0;
    items.forEach(function (el) {
      if (belongsTo(el, variantId)) {
        show(el);
        shown++;
      } else {
        hide(el);
      }
    });

    // Safety net: never leave the shopper staring at an empty gallery. If the
    // variant resolved to nothing (untagged alt text, media not yet assigned),
    // fall back to showing everything rather than showing nothing.
    if (shown === 0) {
      items.forEach(show);
      return false;
    }

    return true;
  }

  function rebuildSliders() {
    // Destroy in the reverse of the order they are created, then re-init in
    // the same order update-slider.js uses: sublist first (the main slider
    // consumes it as its thumbs swiper), then main, then the popup.
    ['.js-popup-slider', '.js-media-list', '.js-media-sublist'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.swiper) {
          try {
            el.swiper.destroy(true, true);
          } catch (err) {
            /* a destroyed instance is still a fine outcome */
          }
        }
      });
    });

    if (typeof subSliderInit === 'function') subSliderInit(false);
    if (typeof sliderInit === 'function') sliderInit(false);
    if (typeof popupSliderInit === 'function') popupSliderInit(false);
  }

  function resetBottomGallery() {
    // The bottom thumb strip is not a Swiper - it is a transform-based track
    // with its own arrow logic in main-product.liquid. Snap it back to the
    // start and mark the first visible thumb active so the strip does not sit
    // scrolled past the end of a now-shorter set.
    var track = document.querySelector('.btg-track');
    if (track) track.style.transform = 'translateX(0px)';

    var thumbs = document.querySelectorAll('.product__media-bottom-thumb:not([' + HIDDEN + '])');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('active', i === 0);
    });

    window.dispatchEvent(new Event('resize'));
  }

  var pending = null;

  function applyVariant(variantId) {
    if (!variantId) return;
    if (pending) window.cancelAnimationFrame(pending);

    pending = window.requestAnimationFrame(function () {
      pending = null;
      filterTo(String(variantId));
      rebuildSliders();
      resetBottomGallery();
    });
  }

  function variantIdFromEvent(e) {
    if (e && e.detail && e.detail.variant) return e.detail.variant.id;
    return null;
  }

  function onVariantEvent(e) {
    applyVariant(variantIdFromEvent(e));
  }

  // global.js dispatches 'variant:change'. Parts of main-product.liquid listen
  // for 'variant:changed'. Bind both so this keeps working whichever of the two
  // the theme settles on.
  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('variant:changed', onVariantEvent);

  // Last-resort fallback: read the hidden variant input the product form keeps
  // in sync, in case neither custom event fires (quick-add, floated form).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches) return;
    if (!input.matches('variant-radios input, variant-selects select')) return;

    window.setTimeout(function () {
      var hidden = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (hidden && hidden.value) applyVariant(hidden.value);
    }, 60);
  });
})();
